import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLinkButton, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { EventDTO } from '../../models/events';
import { SharingCenterService } from '../../services/sharingcenter.service';
import { PlanogramSharedUserDTO } from 'src/app/models/user';
import { RecentEventResults } from 'src/app/models/sharing-center';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-planogram-activity-modal',
    templateUrl: './planogram-activity-modal.component.html',
    styleUrl: './planogram-activity-modal.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, NgbNav, NgFor, NgbNavItem, NgbNavItemRole, NgbNavLinkButton, NgbNavLinkBase, NgbNavContent, NgbNavOutlet, DatePipe]
})
export class PlanogramActivityModalComponent implements OnInit {
  @Input() planogramId!: string;
  @Input() planogramName!: string;

  loading = false;
  sharedUsers: PlanogramSharedUserDTO[] = [];
  userEvents: { [userId: string]: RecentEventResults | null } = {};
  pages: { [userId: string]: number } = {};
  pageSize = 10;

  constructor(
    public activeModal: NgbActiveModal,
    private activityService: SharingCenterService
  ) {}

  ngOnInit(): void {
    if (this.planogramId) this.loadSharedUsers();
  }

  loadSharedUsers(): void {
    this.loading = true;
    this.activityService.getPlanogramSharedUsers(this.planogramId).subscribe((users) => {
      this.loading = false;
      if (users) {
        this.sharedUsers = users;
        // Initialize page tracking
        users.forEach(u => this.pages[u.id!] = 1);
        if (users.length > 0) this.loadUserEvents(users[0].id!); // preload first tab
      }
    });
  }

  loadUserEvents(userId: string): void {
    const page = this.pages[userId] || 1;
    this.userEvents[userId] = null; // trigger loading state for that user
    this.activityService
      .getPlanogramEventsByUser(this.planogramId, userId, page, this.pageSize)
      .subscribe((res) => {
        this.userEvents[userId] = res;
      });
  }

  changePage(userId: string, newPage: number): void {
    this.pages[userId] = newPage;
    this.loadUserEvents(userId);
  }

  close(): void {
    this.activeModal.dismiss();
  }
}